// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__4WjMk","row":"Node_row__3Ir_v","label":"Node_label__1RGmU","footer":"Node_footer__191mI"};